import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_URL, timeout: 8000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken') || localStorage.getItem('token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

class SystemHealthService {
  static async getSnapshot() {
    const res = await api.get('/system-health');
    return res.data;
  }
}

export default SystemHealthService;
